// extracted by mini-css-extract-plugin
module.exports = {"tbody":"table_tbody__2ok6u","tableCell":"table_tableCell__3ms-S"};